// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\MissingPilotJobOrdersViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { MissingPilotJobOrder as _MissingPilotJobOrder, MissingPilotJobOrderData as _MissingPilotJobOrderData, MissingPilotJobOrderOptions as _MissingPilotJobOrderOptions } from 'data/models/MissingPilotJobOrders';
import { MissingPilotJobOrderType } from 'server/enums/MissingPilotJobOrderType';

// MissingPilotJobOrdersResponseData is the class that MissingPilotJobOrdersResponse serializes to/from
export interface MissingPilotJobOrdersResponseData {
    From : /* ISO8601 */ string;
    PortCallId : number | null;
    To : /* ISO8601 */ string;
	
    MissingPilotJobOrders : _MissingPilotJobOrderData[] | null;
	
}

// MissingPilotJobOrdersResponseOptions is the class which may be passed to the MissingPilotJobOrdersResponse constructor to define optional initial data values
export interface MissingPilotJobOrdersResponseOptions {
    From : /* ISO8601 */ string;
    PortCallId : number | null;
    To : /* ISO8601 */ string;
	
    MissingPilotJobOrders? : _MissingPilotJobOrderOptions[] | null;
	
}

export class MissingPilotJobOrdersResponse {
    public From : DataSignal<TZDate>;
    public PortCallId : DataSignal<number | null>;
    public To : DataSignal<TZDate>;
	
    public MissingPilotJobOrders : SDataArray<_MissingPilotJobOrder>;
	

    constructor();
    constructor(data : MissingPilotJobOrdersResponseOptions);
    constructor(data: MissingPilotJobOrdersResponseOptions | null = null) {
        this.From = jsonableObservable(S.value<TZDate>(data && data.From !== undefined ? new TZDate(data.From) : new TZDate(0), TZDate.eq));
        this.PortCallId = jsonableObservable(S.value<number | null>(data && data.PortCallId !== undefined ? data.PortCallId : null));
        this.To = jsonableObservable(S.value<TZDate>(data && data.To !== undefined ? new TZDate(data.To) : new TZDate(0), TZDate.eq));
	    
        this.MissingPilotJobOrders = SArray<_MissingPilotJobOrder>([]);
	    
    }

    static key(obj : MissingPilotJobOrdersResponse) {
        return obj.From().toJSON() + '\u2618' + (obj.PortCallId() === null ? NaN : obj.PortCallId()!) + '\u2618' + obj.To().toJSON();
    }
    
    static dataKey(obj : MissingPilotJobOrdersResponseOptions) {
        return new TZDate(obj.From).toJSON() + '\u2618' + (obj.PortCallId === null ? NaN : obj.PortCallId) + '\u2618' + new TZDate(obj.To).toJSON();
    }

    static update(obj : MissingPilotJobOrdersResponse, data : MissingPilotJobOrdersResponseOptions) {
        S.freeze(() => {
            if (data.From !== undefined) obj.From(new TZDate(data.From));
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.To !== undefined) obj.To(new TZDate(data.To));
	        
	        
        });
    }
}

// MissingPilotJobOrderData is the class that MissingPilotJobOrder serializes to/from
export interface MissingPilotJobOrderData {
    FromPointId : number;
    ToPointId : number;
	
	
    Date : /* ISO8601 */ string;
    FromName : string | null;
    ToName : string | null;
    Type : MissingPilotJobOrderType;
    VesselName : string | null;
}

// MissingPilotJobOrderOptions is the class which may be passed to the MissingPilotJobOrder constructor to define optional initial data values
export interface MissingPilotJobOrderOptions {
    FromPointId : number;
    ToPointId : number;
	
	
    Date? : /* ISO8601 */ string;
    FromName? : string | null;
    ToName? : string | null;
    Type? : MissingPilotJobOrderType;
    VesselName? : string | null;
}

export class MissingPilotJobOrder {
    public FromPointId : DataSignal<number>;
    public ToPointId : DataSignal<number>;
	
	
    public Date : DataSignal<TZDate>;
    public FromName : DataSignal<string | null>;
    public ToName : DataSignal<string | null>;
    public Type : DataSignal<MissingPilotJobOrderType>;
    public VesselName : DataSignal<string | null>;

    constructor();
    constructor(data : MissingPilotJobOrderOptions);
    constructor(data: MissingPilotJobOrderOptions | null = null) {
        this.FromPointId = jsonableObservable(S.value<number>(data && data.FromPointId !== undefined ? data.FromPointId : 0));
        this.ToPointId = jsonableObservable(S.value<number>(data && data.ToPointId !== undefined ? data.ToPointId : 0));
	    
	    
        this.Date = jsonableObservable(S.value<TZDate>(data && data.Date !== undefined ? new TZDate(data.Date) : new TZDate(0), TZDate.eq));
        this.FromName = jsonableObservable(S.value<string | null>(data && data.FromName !== undefined ? data.FromName : null));
        this.ToName = jsonableObservable(S.value<string | null>(data && data.ToName !== undefined ? data.ToName : null));
        this.Type = jsonableObservable(S.value<MissingPilotJobOrderType>(data && data.Type !== undefined ? data.Type : 0));
        this.VesselName = jsonableObservable(S.value<string | null>(data && data.VesselName !== undefined ? data.VesselName : null));
    }

    static key(obj : MissingPilotJobOrder) {
        return obj.FromPointId() + '\u2618' + obj.ToPointId();
    }
    
    static dataKey(obj : MissingPilotJobOrderOptions) {
        return obj.FromPointId + '\u2618' + obj.ToPointId;
    }

    static update(obj : MissingPilotJobOrder, data : MissingPilotJobOrderOptions) {
        S.freeze(() => {
            if (data.FromPointId !== undefined) obj.FromPointId(data.FromPointId);
            if (data.ToPointId !== undefined) obj.ToPointId(data.ToPointId);
	        
	        
            if (data.Date !== undefined) obj.Date(new TZDate(data.Date));
            if (data.FromName !== undefined) obj.FromName(data.FromName);
            if (data.ToName !== undefined) obj.ToName(data.ToName);
            if (data.Type !== undefined) obj.Type(data.Type);
            if (data.VesselName !== undefined) obj.VesselName(data.VesselName);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/MissingPilotJobOrders.ts